import React, { useEffect, useRef, useMemo } from 'react'
import useStyles from './styles'
import Purchase from './Purchase'
import { orderBy } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { Typography, CircularProgress, useMediaQuery } from '@material-ui/core'
import { getItemPurchases } from 'actions/items'
import classnames from 'clsx'
import Scrollbars from 'react-scrollbars-custom'
import AutoSizer from 'react-virtualized-auto-sizer'

const PurchaseList = ({ item, scrollable = true, scrollEffect = false }) => {
  const classes = useStyles()
  const listRef = useRef(null)

  const isMobile = useMediaQuery('(max-width: 767px)')

  const purchasesLoading = useSelector(state => state.items.purchasesLoading)
  const purchases = useSelector(state => state.items.purchases)
  const items = useSelector(state => state.items.items)
  const thisItem = items.find(i => i.item_id === item.item_id)

  const dispatch = useDispatch()

  const updateScroll = () => {
    listRef.current.scrollTop = listRef.current.scrollHeight
  }

  useEffect(() => {
    if (purchases === null) {
      dispatch(getItemPurchases(item.item_id)).then(() => {
        // updateScroll()
      })
    } else {
      // updateScroll()
    }
  }, [])

  const renderThumbVertical = ({ style, ...props }) => {
    return (
      <div style={{ ...style }} className={classes.scrollThumb} {...props} />
    )
  }

  return (
    <AutoSizer>
      {({ height, width }) => (
        <Scrollbars
          ref={listRef}
          style={{
            height: height - 1,
            width
          }}
          noScroll={!scrollable || isMobile}
          removeTracksWhenNotUsed
        >
          {purchases &&
            purchases.length > 0 &&
            orderBy(purchases, 'orderableDate', 'desc').map(purchase => (
              <Purchase
                key={purchase.purchase_id}
                purchase={purchase}
                scrollEffect={scrollEffect}
                parentRef={listRef}
              />
            ))}
          {!purchases && purchasesLoading && (
            <div className={classes.purchasesLoading}>
              <Typography variant="h4" className={classes.loadingTypography}>
                Loading Purchases
              </Typography>
              <CircularProgress />
            </div>
          )}
          {!purchases && !purchasesLoading && (
            <Typography variant="h4" className={classes.noPurchasesTypography}>
              No Purchases Have Been Placed Yet
            </Typography>
          )}
        </Scrollbars>
      )}
    </AutoSizer>
  )
}

export default PurchaseList



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/PurchaseList/index.jsx